import React from 'react'
import styled from 'styled-components'

import Colors from 'styles/Colors'

import { Body, HeadlineM, Overline } from 'components/Text'
import { TextButton } from 'components/Buttons'

import media from 'styles/media'

const Contact: React.FC<{ page: string }> = ({ page }) => {
  return (
    <Wrapper id="contact">
      <TextWrapper>
        <Label bullet>REQUEST DEMO</Label>
        <Title>See RapidPlan in action</Title>
        <Paragraph>
          Tell us about your application and we’ll be in touch
        </Paragraph>
      </TextWrapper>
      <Lines>////////</Lines>
      <Form
        id={`contact-form-${page}`}
        name={`contact-${page}`}
        method="POST"
        data-netlify="true"
        netlify-honeypot="Robot ID"
        action="/thank-you/"
      >
        <input type="hidden" name="form-name" value={`contact-${page}`} />
        <Input
          placeholder="First Name*"
          id="first_name"
          name="first_name"
          type="text"
          aria-label="First Name"
          required
          aria-required
        />
        <Input
          placeholder="Last Name*"
          type="text"
          id="last_name"
          name="last_name"
          aria-label="Last Name"
          required
          aria-required
        />
        <Hidden>
          <label>
            Don't fill this out if you are human
            <Input type="text" name="Robot ID" />
          </label>
        </Hidden>
        <Input
          placeholder="Email*"
          type="email"
          required
          aria-required
          aria-label="Contact Email"
          id="email"
          name="email"
        />
        <Input
          placeholder="Company*"
          required
          aria-required
          type="text"
          aria-label="Company"
        />
        <Input
          placeholder="Job Title*"
          required
          aria-required
          type="text"
          aria-label="Job Title"
        />
        <Text
          placeholder="Message*"
          required
          aria-required
          aria-label="Message"
          name="description"
        />

        <br />
        <Button type="submit" name="submit">
          Request demo
        </Button>
      </Form>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 920px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  ${media.fullWidth} {
    height: 48.8vw;
  }
  ${media.tabletLandscape} {
    height: 112.9vw;
  }
  ${media.tablet} {
    height: 150vw;
  }
  ${media.mobile} {
    height: 209vw;
    min-height: 984px;
  }
`
const TextWrapper = styled.div`
  width: 1080px;
  height: 100%;
  background: ${Colors.softBlack};
  padding: 278px 0 0 378px;
  @media screen and (max-width: 1390px) {
    width: 1000px;
  }
  @media screen and (max-width: 1312px) {
    width: 800px;
    padding-left: 278px;
    padding-right: 150px;
  }
  ${media.fullWidth} {
    width: 64.3vw;
    padding: 16.5vw 0 0 17.1vw;
  }
  ${media.tabletLandscape} {
    width: 100%;
    padding: 16.4vw 0 0 7vw;
  }
`
const Label = styled(Overline)`
  color: white;
  ::after {
    color: ${Colors.neptune};
  }
`
const Title = styled(HeadlineM)`
  color: white;
  margin: 0.9vw 0 1.2vw;
  width: 400px;
  ${media.mobile} {
    line-height: 100%;
    font-size: 36px;
    width: 100%;
  }
`
const Paragraph = styled(Body)`
  color: white;
  width: 400px;
  ${media.mobile} {
    width: 100%;
  }
`
const Lines = styled(HeadlineM)`
  position: absolute;
  color: ${Colors.neptune};
  transform: rotate(-90deg);
  top: 792px;
  right: 62px;
  ${media.fullWidth} {
    top: 41.2vw;
  }
  ${media.tabletLandscape} {
    left: 87.2vw;
    right: auto;
    top: 12.1vw;
    font-size: 36px;
  }
  ${media.mobile} {
    font-size: 24px;
    line-height: 28px;
    right: -11px;
    left: auto;
    width: fit-content;
  }
`
const Form = styled.form`
  width: 606px;
  height: 712px;
  position: absolute;
  top: 102px;
  right: 852px;
  background: white;
  padding: 96px 88px 0;
  * {
    :focus {
      outline: transparent;
    }
  }
  @media screen and (max-width: 1460px) {
    right: 780px;
  }
  @media screen and (max-width: 1390px) {
    right: 700px;
  }
  @media screen and (max-width: 1312px) {
    right: 600px;
  }
  ${media.fullWidth} {
    width: 36.1vw;
    height: 36.7vw;
    top: 6.1vw;
    left: 13.2vw;
    right: auto;
  }
  ${media.tabletLandscape} {
    width: 65.6vw;
    height: 63.6vw;
    top: 43.3vw;
    left: 7vw;
    right: auto;
    padding: 6.2vw 4.6vw 0;
  }
  ${media.tablet} {
    top: 59.9vw;
    width: calc(100vw - 96px);
    left: 48px;
    height: 600px;
    padding: 64px 48px 0;
  }
  ${media.mobile} {
    left: 12px;
    width: calc(100vw - 24px);
    padding: 48px 12px;
  }
  @media screen and (max-width: 600px) {
    height: 560px;
    top: 376px;
    // top: 100.2vw;
  }
`
const Input = styled.input`
  font-family: 'Maison Neue Mono';
  width: 100%;
  height: 48px;
  border: solid 1px ${Colors.softBlack};
  background: rgba(124, 161, 161, 0.12);
  color: ${Colors.softBlack};
  padding-left: 24px;
  font-size: 16px;
  margin-bottom: 24px;
  border-radius: 0;
  box-shadow: none;

  ${media.fullWidth} {
    height: 2.7vw;
    font-size: 1vw;
    padding-left: 1.4vw;
    margin-bottom: 1.4vw;
  }
  ${media.tabletLandscape} {
    height: 4.6vw;
    margin-bottom: 2.3vw;
  }
  ${media.tablet} {
    height: 48px;
  }
`
const Text = styled.textarea`
  font-family: 'Maison Neue Mono';
  width: 100%;
  height: 96px
  border: solid 1px ${Colors.softBlack};
  background: rgba(124, 161, 161, 0.12);
  color: ${Colors.softBlack};
  padding-left: 24px;
  padding-top: 14px;
  font-size: 16px;
  margin-bottom: 1.4vw;
  resize: none;
  border-radius: 0;
  box-shadow: none;
  ${media.fullWidth} {
    height: 5.7vw;
    padding-left: 1.4vw;
    padding-top: 0.8vw;
    font-size: 0.9vw;
    margin-bottom: 1.4vw;
  }
  ${media.tabletLandscape}{
    height: 9.4vw;
  }
  ${media.tablet} {
    height: 96px;
    
  }
`
const Button = styled(TextButton)`
  width: 136px;
  ${media.fullWidth} {
    width: 8.1vw;
  }
  ${media.tabletLandscape} {
    margin-left: 43vw;
    width: 13.2vw;
    margin-top: 4.6vw;
  }
  ${media.tablet} {
    width: 136px;
    position: absolute;
    right: 48px;
  }
  ${media.mobile} {
    right: 12px;
  }
  @media screen and (max-width: 600px) {
    width: calc(100% - 24px);
    margin-top: 40px;
  }
`
const Hidden = styled.div`
  height: 0;
  width: 0;
  overflow: hidden;
`

export default Contact
